<template>
  <div class="footer">


    <el-footer>
      <div class="tContent">
        <div class="f_t">
          <div class="f_t_l">
            <div class="f_logo" style="width: 210px;height: 50.4px;">
              <img :src="logo ? logo : bdLogo" alt="logo" style="width: 100%;height: 100%;">
            </div>
            <div class="f_tel">
              <p>咨询热线：</p>
              <p class="t_txt">{{ phone }}</p>
            </div>

          </div>
          <div class="f_t_m">
            <ul>
              <li>
                <router-link to="/">首页</router-link>
              </li>
              <li>
                <router-link to="">新闻</router-link>
                <router-link v-for="item in newList" :key="item.id" :to="'/news?type=' + item.value">{{ item.label
                  }}</router-link>
              </li>
              <li>
                <router-link to="">频道</router-link>
                <router-link to="/service">专业服务交流</router-link>
                <router-link to="/resourceShare">资源共享</router-link>
              </li>
              <li>
                <router-link to="">获取服务项目</router-link>
                <router-link to="/designer">专业团队</router-link>
                <router-link to="/selectedProjects">精选项目</router-link>
                <router-link to="/successProjects">成功案例</router-link>
              </li>
              <li>
                <router-link to="">我的</router-link>
                <router-link to="/myIndex">个人中心</router-link>
                <router-link to="/myProjectRelease">发布项目</router-link>
                <router-link to="/myComment">我的评论</router-link>
              </li>
            </ul>


          </div>
          <div class="f_t_r">
            <p>关注我们：</p>
            <div class="icons">
              <div v-if="wx">
                <el-popover v-if="wx.type == 0" placement="top" width="200" trigger="click" :content="wx.sysValue">
                  <i class="fainro fr-weixin" slot="reference"></i>
                </el-popover>
                <el-popover v-if="wx.type == 1" placement="top" width="100" trigger="click">
                  <el-image :src="wx.sysValue" fit="cover"></el-image>
                  <i class="fainro fr-weixin" slot="reference"></i>
                </el-popover>
                <i v-if="wx.type == 2" class="fainro fr-weixin" @click="gotoAbout(wx.sysKey)"></i>
                <i v-if="wx.type == 3" class="fainro fr-weixin" @click="gotoWw(wx.sysValue)"></i>


              </div>
              <div v-if="wb">
                <el-popover v-if="wb.type == 0" placement="top" width="200" trigger="click" :content="wb.sysValue">
                  <i class="fainro fr-weibo" slot="reference"></i>
                </el-popover>
                <el-popover v-if="wb.type == 1" placement="top" width="100" trigger="click">
                  <el-image :src="wb.sysValue" fit="cover"></el-image>
                  <i class="fainro fr-weibo" slot="reference"></i>
                </el-popover>
                <i v-if="wb.type == 2" class="fainro fr-weibo" @click="gotoAbout(wb.sysKey)"></i>
                <i v-if="wb.type == 3" class="fainro fr-weibo" @click="gotoWw(wb.sysValue)"></i>
              </div>
              <div v-if="dy">
                <el-popover v-if="dy.type == 0" placement="top" width="200" trigger="click" :content="dy.sysValue">
                  <i class="fainro fr-douyin" slot="reference"></i>
                </el-popover>
                <el-popover v-if="dy.type == 1" placement="top" width="100" trigger="click">
                  <el-image :src="dy.sysValue" fit="cover"></el-image>
                  <i class="fainro fr-douyin" slot="reference"></i>
                </el-popover>
                <i v-if="dy.type == 2" class="fainro fr-douyin" @click="gotoAbout(dy.sysKey)"></i>
                <i v-if="dy.type == 3" class="fainro fr-douyin" @click="gotoWw(dy.sysValue)"></i>
              </div>
              <div v-if="xhs">
                <el-popover v-if="xhs.type == 0" placement="top" width="200" trigger="click" :content="xhs.sysValue">
                  <img class="imgIcon" :src="xhsIcon" alt="" slot="reference">
                </el-popover>
                <el-popover v-if="xhs.type == 1" placement="top" width="100" trigger="click">
                  <el-image :src="xhs.sysValue" fit="cover"></el-image>
                  <img class="imgIcon" :src="xhsIcon" alt="" slot="reference">
                </el-popover>
                <img v-if="xhs.type == 2" class="imgIcon" :src="xhsIcon" alt="" @click="gotoAbout(xhs.sysKey)">
                <img v-if="xhs.type == 3"  class="imgIcon" :src="xhsIcon" alt="" @click="gotoWw(xhs.sysValue)">
                

              </div>
              <div v-if="qq">
                <el-popover v-if="qq.type == 0" placement="top" width="200" trigger="click" :content="qq.sysValue">
                  <i class="fainro fr-QQ" slot="reference"></i>
                </el-popover>
                <el-popover v-if="qq.type == 1" placement="top" width="100" trigger="click">
                  <el-image :src="qq.sysValue" fit="cover"></el-image>
                  <i class="fainro fr-QQ" slot="reference"></i>
                </el-popover>
                <i v-if="qq.type == 2" class="fainro fr-QQ" @click="gotoAbout(qq.sysKey)"></i>
                <i v-if="qq.type == 3" class="fainro fr-QQ" @click="gotoWw(qq.sysValue)"></i>

              </div>
            </div>

          </div>
        </div>
        <div class="f_b">
          <div class="f_b_l">
            <p>Copyright © 2024 新一代数字化户外视觉媒体产业平台</p>
          </div>
          <div class="f_b_r">
            <p><span style="cursor: pointer;" @click="gotoAbout(gywm.sysKey)">{{ gywm.sysName
                }}</span>&ensp;|&ensp;<span style="cursor: pointer;" @click="gotoAbout(lxwm.sysKey)">{{ lxwm.sysName
                }}</span>&ensp;|&ensp;<span style="cursor: pointer;" @click="gotoAbout(bqsm.sysKey)">{{ bqsm.sysName
                }}</span></p>
          </div>
        </div>
      </div>

    </el-footer>

  </div>
</template>

<script>
import { getSimple, getInfoByKeys } from '@/api/api'
import bdLogo from '@/assets/images/logo1.png'
import xhsIcon from '@/assets/images/xhs.png'

export default {
  data() {
    return {
      xhsIcon,
      newList: [],
      logo: '',
      bdLogo,
      phone: '',
      lxwm: '',
      gywm: '',
      bqsm: '',
      wx: {},
      wb: {},
      dy: {},
      xhs: {},
      qq: {},

    };
  },
  created() {
    this.doGetSimple()
    this.doGetInfoByKeys()

  },
  methods: {
    gotoAbout(key) {
      this.$router.push('/about?key=' + key).catch(err => { console.log('err ' + err) })
    },
    gotoWw(url) {
      window.open(url)
    },

    //获取字典
    doGetSimple() {
      getSimple().then(res => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'news_kind') {
              this.newList = res.data[i].sons
            }

          }
        }
      }).catch(err => { console.log('err ' + err) })
    },
    //获取系统设置
    doGetInfoByKeys() {
      getInfoByKeys().then(res => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].sysKey == 'logo') {
              this.logo = res.data[i].sysValue
            }
            if (res.data[i].sysKey == 'telphone') {
              this.phone = res.data[i].sysValue ? res.data[i].sysValue.replace(/(\d{4})(?=\d)/g, '$1 ') : ''
            }
            if (res.data[i].sysKey == 'about_us') {
              this.gywm = res.data[i]
            }
            if (res.data[i].sysKey == 'contact_us') {
              this.lxwm = res.data[i]
            }
            if (res.data[i].sysKey == 'copyright') {
              this.bqsm = res.data[i]
            }
            if (res.data[i].sysKey == 'link_qq') {
              this.qq = res.data[i]
            }
            if (res.data[i].sysKey == 'link_wx') {
              this.wx = res.data[i]
            }
            if (res.data[i].sysKey == 'link_wb') {
              this.wb = res.data[i]
            }
            if (res.data[i].sysKey == 'link_dy') {
              this.dy = res.data[i]
            }
            if (res.data[i].sysKey == 'link_xhs') {
              this.xhs = res.data[i]
            }
          }
        }
      }).catch(err => { console.log('err ' + err) })
    },

  }

}
</script>

<style lang="less" scoped>
/deep/ .el-footer {
  height: 100% !important;
}

.footer {
  padding: 40px 0 20px 0;
  width: 100%;
  background-color: #000;
  color: #909399;

  .tContent {
    font-size: 14px;
    .f_t {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      height: 160px;

      .f_tel {
        margin-top: 20px;

        p {
          margin-top: 10px;
        }

        .t_txt {
          font-size: 28px;
          color: #fff;
          font-weight: bold;
        }
      }

      .f_t_m {
        ul {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;

          li {
            margin: 0 20px;

            a {
              display: block;
              margin-bottom: 10px;
              color: #909399;

              &:first-child {
                color: #fff;
                font-weight: bold;
                margin-bottom: 20px;
              }
            }
          }
        }
      }

      .f_t_r {

        p {
          margin-left: 10px;
          margin-bottom: 10px;
          color: #fff;
        }

        .icons {
          display: flex;
          align-items: center;

          div {
            margin-left: 10px;
            position: relative;

            i {
              font-size: 32px;
              color: #959595;

            }

            .imgIcon {
              height: 26px;
            }
          }
        }

      }

    }

    .f_b {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
    }
  }
}
</style>